import { RiFileCopyLine } from '@remixicon/react';
import { createIconFromRemixIcon } from './utils/createIcons.js';

const CopyIcon = createIconFromRemixIcon(RiFileCopyLine);

export { CopyIcon };
